import { Checkbox, SelectV2, SelectV2Option } from '@cimplico/components';
import { useState } from 'react';
import { useFYIJobs } from '../../queries/use-fyi-jobs';
import HelpIcon from '../help-icon/HelpIcon';

type FYIJobSelectProps = {
    fyiEntityId: number;
    title?: string;
    isOptional?: boolean;
    placeholder?: string;
    form?: string;
    isDisabled?: boolean;
    onChange: (job?: { id: string; name: string }) => void;
    hint?: string;
    selectedJob?: { name: string; id: string };
};

function FYIJobSelect({
    fyiEntityId,
    title,
    isOptional = false,
    placeholder,
    form,
    isDisabled,
    onChange,
    hint,
    selectedJob,
}: FYIJobSelectProps): JSX.Element {
    const [showClosed, setShowClosed] = useState(false);
    const [search, setSearch] = useState<string>();
    const { isLoading, data } = useFYIJobs(fyiEntityId, { name: search, excludeClosed: !showClosed });

    const jobs = data?.jobs || [];

    function handleChange(values: SelectV2Option[]): void {
        const value = values[0];
        if (value) {
            const job = { name: value.label, id: value.value.toString() };

            onChange(job);
        } else {
            onChange(undefined);
        }
    }

    return (
        <>
            <div className="mb-2 flex items-center gap-2">
                <Checkbox label="Include closed jobs" defaultChecked={showClosed} onChange={(e): void => setShowClosed(e.target.checked)} />
                <HelpIcon message="Show FYI jobs that are marked as complete, on hold, cancelled or archived." />
            </div>
            <SelectV2
                placeholder={placeholder || 'Select a job...'}
                title={title}
                form={form}
                isOptional={isOptional}
                isMulti={false}
                isLoading={isLoading}
                value={selectedJob ? [{ label: selectedJob.name, value: selectedJob.id }] : []}
                options={jobs.map((j) => ({
                    value: j.id,
                    label: j.name,
                }))}
                onSearch={setSearch}
                onChange={handleChange}
                disabled={isDisabled}
                hint={hint}
            />
        </>
    );
}
export default FYIJobSelect;
